import React from 'react';
import { useMutation, Link } from 'react-admin';

const ButtonServiceAdminShow = ({ record }) => {
    const [{ loading }] = useMutation();

    return (
      <Link
       disabled={loading}
       to={'/service-admin/' + record.id + '/show'}
       onClick={ (e) => { e.stopPropagation() }}>
       Detalhes
     </Link>
   );
};

export default ButtonServiceAdminShow;
